import React from 'react';
import PropTypes from 'prop-types';
import ContactForm from '../ContactForm';
import SellerInformation from '../SellerInformation';
import messages from '../../utils/translationMessages';
import { formatMessage as t, getCurrentLocale } from '../../utils/language';

import './styles.css';

const OemContactForm = (props) => {
  const {
    id,
    contact,
    partyId,
    prePopulatedText,
    proximity,
    onSuccess,
    zipCode,
    oemDetails,
    listingId,
    ownerId,
    listing,
    contactFormTitle
  } = props;

  let showCountry = true;
  let showZipCode = false;
  let orderInputs = ['name', 'email', 'phone', 'country', 'comments'];

  if (getCurrentLocale() === 'us') {
    showZipCode = true;
    showCountry = false;
    orderInputs = ['name', 'email', 'phone', 'zip', 'comments'];
  }

  return (
    <div className="oem-contact-form">
      {contact && (
        <SellerInformation
          contact={contact}
          proximity={proximity}
          zipCode={zipCode}
          id="oem-dealer-info"
          revealDealerPhoneNumber
        />
      )}
      <ContactForm
        id={id}
        listingContact={contact}
        open={true}
        partyId={partyId}
        contactButtonText={t(messages.detailsManufacturer.dealerContactButton)}
        prePopulatedText={prePopulatedText}
        placeholderText={{
          name: t(messages.contactForm.fullName),
          email: t(messages.contactForm.yourEmail),
          phone: t(messages.contactForm.yourPhone),
          zip: t(messages.postalCode),
          country: t(messages.contactForm.selectCountry),
          comments: t(messages.contactForm.comments)
        }}
        orderInputs={orderInputs}
        showZipCode={showZipCode}
        showCountry={showCountry}
        labelText={{
          name: t(messages.contactForm.firstName),
          email: t(messages.contactForm.email),
          phone: t(messages.contactForm.phone),
          zip: t(messages.postalCode),
          country: t(messages.contactForm.country),
          comments: t(messages.contactForm.comments)
        }}
        onSuccess={onSuccess}
        showTermsAndPrivacy={true}
        onlyShowError
        isOemDealer={true}
        copyOem={Boolean(
          oemDetails.dealerLocator && oemDetails.emailManufacturer
        )}
        oemId={ownerId}
        brandId={oemDetails.brandId}
        listingId={listingId}
        itemId={listingId}
        listing={listing}
        contactSubmitTrack={true}
        leadType={ContactForm.TYPES.dealer}
        title={contactFormTitle}
      />
    </div>
  );
};

OemContactForm.propTypes = {
  id: PropTypes.any,
  contact: PropTypes.any,
  partyId: PropTypes.any,
  prePopulatedText: PropTypes.any,
  proximity: PropTypes.any,
  onSuccess: PropTypes.func,
  type: PropTypes.any,
  zipCode: PropTypes.any,
  oemDetails: PropTypes.any,
  listingId: PropTypes.any,
  ownerId: PropTypes.any,
  listing: PropTypes.any,
  contactFormTitle: PropTypes.string
};

export default OemContactForm;
